import userService from "../../../services/user.service";

async function getTaskStatuses({
  pageNumber = -1,
  pageSize = 0,
  searchQuery = "",
}) {
  try {
    const response = await userService.getTaskStatuses(
      pageNumber,
      pageSize,
      searchQuery
    );
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch task statuses."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching task statuses:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getTaskStatuses,
  taskStatusTools: [
    {
      type: "function",
      function: {
        name: "getTaskStatuses",
        description: "Fetch all task statuses from the database.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "integer",
              description:
                "Page number for pagination by default it is -1 for fetching all tasks statuses",
            },
            pageSize: {
              type: "integer",
              description:
                "Number of items per page by default it is 0 for fetching all task statuses",
            },
            searchQuery: {
              type: "string",
              description:
                "Search keyword for filtering task statuses by default it is empty string for fetching all task statuses",
            },
          },
          required: [],
        },
      },
    },
  ],
};
